
import React from 'react';
import { useSelector } from 'react-redux';
import { EDSModal } from '@gehc-eds-react/eds-modal';
import { selectDisallowedFilenameChars } from '../../redux/slices/fileExtensionsSlice';

const FilenameErrorModal = ({ isOpen, onClose, unsupportedFiles }) => {
  const disallowedChars = useSelector(selectDisallowedFilenameChars);
  return (
    <EDSModal
      variant="standard"
      isOpen={isOpen}
      headerConfig={{ text: 'Unsupported File Names', useCancelIcon: false }}
      footerConfig={{
        acceptButton: {
          label: 'OK',
          type: 'button',
        },
      }}
      width="500px"
      onEDSModalButtonClickAccept={onClose}
      onEDSModalClose={onClose}
      content={
        <div slot="main-content">
          <div style={{ padding: '16px', fontSize: 15 }}>
            Some of the files in the dataset contain characters that are not allowed.<br />
            <br />
            <strong>Allowed file name format:</strong><br />
            File names must not contain any of the following characters:<br />
            <span style={{ color: '#d32f2f', fontFamily: 'monospace', fontSize: 14 }}>
              {disallowedChars && disallowedChars.length > 0
                ? ' ' + disallowedChars.join(' ')
                : ' (loading...)'}
            </span>
            <br /><br />
            <strong>Example:</strong> <span style={{ fontFamily: 'monospace', fontSize: 14 }}>patient_data_2024.csv</span><br />
            <br />
            Please rename the files and try uploading again.
          </div>
        </div>
      }
    />
  );
};

export default FilenameErrorModal;
